module.exports = __webpack_public_path__ + "static/media/home-swipe-two.fd7c3853.png";